import React from 'react';
import PropTypes from 'prop-types';
import StepsOptions from './StepsOptions';
import Row from 'kepler/lib/components/Row';
import getContent from '../lib/dictionaryFetcher';
import { stepPageFPTI } from '../lib/quizStaticMapping';
import { get } from 'lodash';
export default class Steps extends React.Component {
  componentDidMount() {
    const { fptiHelper, stepNumber, location } = this.props,
      stepPageFPTIVal = get(stepPageFPTI, `${stepNumber}`, '');
    fptiHelper.fptiImpression({
      page: `main:businessweb:mep:dashboard:main:quiz:${stepPageFPTIVal}`,
      entry_point: get(location, 'search', '').includes('appcenter=true')
    });
  }
  handleClick = e => {
    const { fptiHelper, stepNumber, location } = this.props,
      stepPageFPTIVal = get(stepPageFPTI, `${stepNumber}`, '');
    if (e.target.classList.contains('step2-app-center')) {
      fptiHelper.fptiClick({
        page: `main:businessweb:mep:dashboard:main:quiz:${stepPageFPTIVal}`,
        entry_point: get(location, 'search', '').includes('appcenter=true'),
        link: 'app_center'
      });
    }
  };
  render() {
    let { steps, noProductsSelectedError, handleChange, products } = this.props;
    return (
      <div className="step" onClick={this.handleClick}>
        <h1 className="step-header">{steps.title}</h1>
        <p
          className="step-info"
          dangerouslySetInnerHTML={{ __html: steps.subtitle }}
        />
        {noProductsSelectedError && (
          <div className="step-error-container">
            <div
              className="ppvx_text-input__error-text step-error-container-image"
              style={{ margin: '0px' }}
            >
              <span className="step-error-container-text">
                {getContent('quiz', 'stepError', '')}
              </span>
            </div>
          </div>
        )}
        <Row>
          <StepsOptions
            steps={steps}
            handleChange={handleChange}
            products={products}
          />
        </Row>
      </div>
    );
  }
}
Steps.propTypes = {
  steps: PropTypes.object.isRequired,
  handleChange: PropTypes.func,
  products: PropTypes.array,
  noProductsSelectedError: PropTypes.bool,
  stepNumber: PropTypes.string,
  location: PropTypes.object,
  fptiHelper: PropTypes.object
};
